module.exports = __webpack_public_path__ + "img/D3.d3d350f5.svg";